import { TooltipContent, TooltipRoot, TooltipTrigger, tokens } from "@blurb/codex-react";
import { Flex, IconV3 } from "@rpi/openapi-core";
import React from "react";
import { Body, Label } from "../../../components/Typography";

interface LabeledFieldProps {
  label: string;
  value: React.ReactNode;
  tooltip?: string;
  testId?: string;
}

/** A semibold label above its value, with an optional info tooltip beside the label. */
export const LabeledField: React.FC<LabeledFieldProps> = ({ label, value, tooltip, testId }) => (
  <Flex.Column gap={4} sx={{ flex: "1 0 0", minWidth: 160, wordBreak: "break-word" }}>
    <Flex.Row gap={6} align="center" sx={{ color: tokens.color.semantic.text.subtle }}>
      <Label>{label}</Label>
      {tooltip && <FieldTooltip label={label} content={tooltip} />}
    </Flex.Row>
    <Body data-testid={testId}>{value}</Body>
  </Flex.Column>
);

const FieldTooltip: React.FC<{ label: string; content: string }> = ({ label, content }) => (
  <TooltipRoot>
    <TooltipTrigger
      render={
        <div aria-label={`${label} information`} tabIndex={0}>
          <IconV3 icon="info" size={16} color={tokens.color.semantic.icon.subtle} />
        </div>
      }
    />
    <TooltipContent>{content}</TooltipContent>
  </TooltipRoot>
);
